import { Service } from '@genial/services';
import { useRecoilValue } from 'recoil';

import { advisorIdToApisSelector } from '../master/selector';

import { screenName } from './constants';

export const useSubscriptionActions = () => {
  const selectedAdvisor = useRecoilValue(advisorIdToApisSelector);

  const cancelSubscriptionRequest = async (subscriptionRequestId: number) => {
    return Service.Equities.V1.postSubscriptionCancel({
      screenName,
      subscriptionCancelRequest: {
        subscriptionRequestId,
        advisorId: selectedAdvisor,
      },
    });
  };

  const executeSubscriptionSolicitation = async (
    eventId: number,
    optInLeftovers: boolean,
    pnpAccountId: number,
    quantity: number
  ) => {
    return Service.Equities.V1.postSubscriptionExecute({
      screenName,
      subscriptionExecuteRequest: {
        advisorId: selectedAdvisor,
        eventId,
        optInLeftovers,
        pnpAccountId,
        quantity,
      },
    });
  };

  return {
    cancelSubscriptionRequest,
    executeSubscriptionSolicitation,
  };
};
